import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  stroke: "currentColor",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm2.5 7.5a1 1 0 0 1 2 0v3a1 1 0 0 1-2 0Zm-7 0a1 1 0 0 1 2 0v3a1 1 0 0 1-2 0Zm10 8.05a6.51 6.51 0 0 1-10.9 0 1 1 0 1 1 1.68-1.1 4.49 4.49 0 0 0 7.54 0 1 1 0 1 1 1.68 1.1Z",
      style: {"fill":"#fff"},
      transform: "scale(2)"
    }, null, -1)
  ])))
}
export default { render: render }